var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":true,"title":"Subscribe to Catalog"}}),_c('ContentRow',[_c('SectionTitle',[_vm._v("Subscribe To Quaid Catalogue")]),_c('ContentContainer',{staticClass:"content-container--narrow"},[_c('Form',{attrs:{"type":"Variations.Quaid.SubscribeForm"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }